import { Routes, RouterModule } from '@angular/router';
import { LoginLayoutComponent } from './layout/login-layout.component';
import { AccountSelectorComponent } from './account_selector/account-selector.component';
import { LoginSelectorComponent } from './selector/login-selector.component';

const LoginRoutes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginSelectorComponent,
      },
      {
        path: 'account_selector',
        component: AccountSelectorComponent,
      },
    ],
  },
];

export const LoginRouting = RouterModule.forChild(LoginRoutes);
